import { create } from 'zustand'
import { AtlasSlice, createAtlasSlice } from './slices'
import { WinLineCombinationData, WinLineData } from 'game-ui-types'

interface InfoLineStore extends AtlasSlice {
    isTextVisible: boolean
    text: string
    winLineData: WinLineData | null
    winLineCombosArray: WinLineCombinationData[]
    freespinText: string
    updateTextVisibility: (isVisible: boolean) => void
    updateText: (newText: string) => void
    updateWinLineData: (newWinLineData: WinLineData | null) => void
    updateFreespinText: (freespinText: string) => void
}

export const useInfoLineStore = create<InfoLineStore>((set, get) => ({
    isTextVisible: false,
    text: '',
    atlasUrl: '',
    frames: [],
    winLineData: null,
    winLineCombosArray: [],
    freespinText: '',
    updateTextVisibility: (isVisible) => set(() => ({ isTextVisible: isVisible })),
    updateText: (newText) => set(() => ({ text: newText })),
    updateWinLineData: (newWinLineData) =>
        set(() => {
            const arr: WinLineCombinationData[] = []

            if (newWinLineData && Object.keys(newWinLineData).length > 0) {
                const defaultCombo = { ...newWinLineData }

                arr.push(defaultCombo)

                if (newWinLineData.extraCombinations) {
                    delete defaultCombo.extraCombinations
                    arr.push(...newWinLineData.extraCombinations)
                }
            }

            return { winLineData: newWinLineData, winLineCombosArray: arr }
        }),
    updateFreespinText: (newFreespinText) => set(() => ({ freespinText: newFreespinText })),
    ...createAtlasSlice(set, get),
}))
